/*globals $, noUiSlider*/
'use strict';

// Include base block
var Block = require('../libs/block');
var FormsetManager = require('../libs/django-formset-manager');

// Pattern to help with time input
// Matches 0000 or 00.00 and converts to 00:00
var TIME_HELPER_PATTERN = /^(\d{2})(\.)?(\d{2})$/;

// Create new block
module.exports = Block.extend({
    template: '#creator',

    /**
     * Basic Block-initialization
     */
    init: function () {
        // Create FormsetMangager, so that we can add/remove items on the fly
        this.formsetManger = new FormsetManager(this.hooks.creatorForm, {
            eventsHook: this._applyRowEvents.bind(this),
            parentSelector: '.slider-holder:first'
        });

        this.hooks.creatorForm.submit(function () {
            this.hooks.submitButton.attr('disabled', 'disabled').addClass('disabled');
        }.bind(this));
    },

    _applyRowEvents: function (parent) {
        // Register new bootstrap date & datetime fields
        window.DateTimeFieldHelpers();
        console.log('added datetime widge')
        // Make an unix timestamp from time string e.g. 08:13:41
        function timestamp(time) {
            time = time.split(':');
            var result = new Date();
            result.setHours(time[0]);
            result.setMinutes(time[1]);
            result.setSeconds(time[2]);
            result.setMilliseconds(0);
            return result.getTime();
        }

        // Formatter for converting unix timestamp to human readable time and back
        var formatter = {
            to: function (value) {
                return new Date(value).toTimeString().substr(0, 5);
            },
            from: function (value) {
                return timestamp(value);
            } 
        };

        parent.find('.slider').each(function (index, elem) {
            var parent = $(elem).parents('.slider-holder:first');
            var startTime = parent.find('.startTime');
            var endTime = parent.find('.endTime');

            // noUiSlider configuration
            // @see https://refreshless.com/nouislider/
            noUiSlider.create(elem, {
                start: [timestamp(startTime.val() || '08:00:00'), timestamp(endTime.val() || '16:00:00')],
                step: 1800000 , // Half an hour
                connect: true,
                tooltips: [formatter, formatter],
                range: {
                    'min': timestamp('00:00:00'),
                    'max': timestamp('23:00:00')
                },
                pips: {
                    mode: 'steps',
                    density: 4,
                    filter: function (value) {
                        var dateVal = new Date(value);
                        if (dateVal.getMinutes() == 0) {
                            return dateVal.getHours() % 2 ? 0 : 1;
                        }
                        return 0;
                    },
                    format: formatter
                }
            }).on('update', function (values) {
                startTime.val(new Date(parseInt(values[0])).toTimeString().substr(0, 8));
                endTime.val(new Date(parseInt(values[1])).toTimeString().substr(0, 8));
            });
        });
    }
});
